export default {"card":"wN3UR","title":"b-TQq","contents":"ewVM-","body":"g9mdN","photo":"o2qzN"};